import { render, staticRenderFns } from "./predicted-team-modal.vue?vue&type=template&id=342a9700&"
import script from "./predicted-team-modal.vue?vue&type=script&lang=js&"
export * from "./predicted-team-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports